// extracted by mini-css-extract-plugin
module.exports = {"poweredBySidebar":"Footnote_poweredBySidebar__3WQzf"};